import React from 'react';
import './index.css';

const DataListBodyRow = (props) => {
	return (
		<div className={`data-list__body__row row no-gutters align-items-center py-2${props.className ? " " + props.className : ''}`}>
			{props.children}
		</div>
	)
};

export default DataListBodyRow;